import { classnames, userGetFullName } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { UserSimpleInfoProps as Props } from './types';

export const UserSimpleInfo = memo(({ className, user, sx }: Props) => {
  return (
    <Styled.Wrapper className={classnames('UserSimpleInfo', className)} sx={sx}>
      <Stack>
        <Styled.Email variant="body3" sx={SX.infoName} width="150px">
          {userGetFullName(user)}
        </Styled.Email>
        <Styled.Email variant="body5" sx={SX.infoEmail} width="150px">
          {user?.username}
        </Styled.Email>
      </Stack>
    </Styled.Wrapper>
  );
});

UserSimpleInfo.displayName = 'UserSimpleInfo';
